module.exports = __webpack_public_path__ + "static/img/22.f9c627b6.jpg";